'use strict';
'use es6';

// ⚠️ Hello HubSpotters, Please don't import from this module. ☠️

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uniqueId = exports.min = exports.max = exports.last = exports.isNaN = exports.first = undefined;

var _lodash = require('../../vendor/lodash.custom');

// allow `uniqueIdLocal` export to be spied. imports are immutable in babel 7
var uniqueIdLocal = _lodash.uniqueId;

/** Returns the first element of an Array or NodeList */
var first = function first(list) {
  return list == null || list.length === 0 ? undefined : list[0];
};

/** Returns the last element of an Array or NodeList */
var last = function last(list) {
  return list == null || list.length === 0 ? undefined : list[list.length - 1];
};

exports.first = first;
exports.isNaN = _lodash.isNaN;
exports.last = last;
exports.max = _lodash.max;
exports.min = _lodash.min;
exports.uniqueId = uniqueIdLocal;